import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://317d2a2048264e00ba955b1c9a8f2d2c@sentry.io/1516971',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
})

// import { captureMessage, captureException } from '@sentry/browser'

// captureMessage('Something went wrong')

// try {
//   aFunctionThatMightFail();
// } catch (err) {
//   captureException(err);
// }



// WEBPACK FOOTER //
// ./src/sentry.js